import type { FaireProductEntity } from "../../entity_types/product";

export const p_sbbqkzzcv7: FaireProductEntity = {
  token: "p_sbbqkzzcv7",
  type: "product",
  name: "Badass Grandma Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/88365cdb2a9c978fe99ae67c27779b9455bf842f3fed5ef2be18b257d6e7abb5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/99e5ee0e61aaecd3bc75f01d14b33e726f3b17e81c4e37b14451b1c8940163d9.jpeg",
    "https://cdn.faire.com/fastly/c8a268ad1310d89954cf9a7f9a4815df9bfe751817a58074c713f67673bd6059.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/679d938bf5b09f37da93ecc4f120eb7c13e7224880b3d8583618040a2ed2bbcc.jpeg",
    "https://cdn.faire.com/fastly/f2279c35fa684af66c27146fc9eecda2572b863f8d24c1f5b4937d3853c80dd0.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the grandma who’s equal parts sweet and unstoppable (and just a little scary). Get her some serious socks to match her vibe.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:56.693Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
